<template>
  <v-card style="overflow: hidden">
    <v-row no-gutters align="stretch">
      <v-col cols="2" class="primary text-center py-2 d-flex flex-column justify-center">
        <div class="white--text" v-text="$t('trainingsession.fields.ontime.title')" />
        <v-simple-checkbox
          v-model="internalValue.active"
          class="mt-1"
          dark
          @input="change"
        />
      </v-col>
      <v-col>
        <v-row no-gutters justify="center" class="px-5">
          <v-col cols="6" class="px-5">
            <v-tooltip
              :value="internalValue.active && !internalValue.versionId"
              top
              nudge-bottom="20"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  v-model="internalValue.versionId"
                  :items="onTimeVersionList"
                  :label="$t('trainingsession.fields.ontime.versionId')"
                  :rules="internalValue.active ? $options.rules.versionId : []"
                  :disabled="!internalValue.active"
                  item-text="name"
                  item-value="id"
                  v-bind="attrs"
                  v-on="on"
                  @input="change"
                />
              </template>
              <span v-text="$t('trainingsession.fields.ontime.versionWarning')" />
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'

export default {
  name: 'OntimeSessionForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    onTimeVersionList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    internalValue: null,
  }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.internalValue = Helpers.clone(this.value)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
    },
  },
  rules: {
    versionId: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
